import { Box, Button } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import FlexBox from "components/flexbox/FlexBox";
import { H1, Paragraph } from "components/Typography";
import { useNavigate } from "react-router-dom";

/**
 * Shown when the user navigates to a route they are not permitted to view.
 * Renders inside the dashboard layout so sidebar remains available.
 */
const AccessDenied = ({
  title = "Access Denied",
  message = "You do not have permission to access this page.",
}) => {
  const navigate = useNavigate();

  return (
    <FlexBox
      p={4}
      minHeight="60vh"
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      textAlign="center"
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "action.hover",
          color: "error.main",
          mb: 2,
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 36 }} />
      </Box>
      <H1 fontSize={28} fontWeight={700} mb={1}>
        {title}
      </H1>
      <Paragraph color="text.secondary" maxWidth={420} mb={3}>
        {message}
      </Paragraph>
      <Button variant="contained" color="primary" onClick={() => navigate(-1)}>
        Go Back
      </Button>
    </FlexBox>
  );
};

export default AccessDenied;
